import { render, staticRenderFns } from "./TopMenuBar.vue?vue&type=template&id=3f0444b8"
import script from "./TopMenuBar.vue?vue&type=script&lang=js"
export * from "./TopMenuBar.vue?vue&type=script&lang=js"
import style0 from "./TopMenuBar.vue?vue&type=style&index=0&id=3f0444b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports